import styled, { device, css } from "@theme/utils";
export const TitleBox = styled.div`
    margin-bottom: 40px;
`;
export const SubTitle = styled.h5`
    font-weight: 700;
    line-height: 1.292;
    text-transform: uppercase;
    font-size: 20px;
    background: -webkit-gradient(to right, (#00cfff, #146c82));
    background: -webkit-linear-gradient(to right, #00cfff, #146c82);
    background: -o-linear-gradient(to right, #00cfff, #146c82);
    background: linear-gradient(to right, #00cfff, #146c82);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    position: relative;
`;
export const Title = styled.h2`
    font-size: 38px;
    background: "red";
`;
export const ShortDec = styled.p``;
export const DividerBar = styled.span`
    position: relative;
    width: 30px;
    height: 5px;
    display: inline-block;
    border-radius: 5px;
    margin-left: 30px;
    &::before,
    &::after {
        width: 15px;
        height: 100%;
        content: "";
        position: absolute;
        top: 0;
        background: #e6e9f5;
        border-radius: 5px;
    }
    &::before {
        left: -30px;
    }
    &::after {
        right: -30px;
    }

    ${({ dividerBg }) =>
        dividerBg === "primary" &&
        css`
            background-image: linear-gradient(0deg, #00cfff 0%, #146c82 100%);
            &::before,
            &::after {
                background: #e6e9f5;
            }
        `};
    ${({ dividerBg }) =>
        dividerBg === "secondary" &&
        css`
            background-image: linear-gradient(0deg, #00cfff 0%, #146c82 100%);
            &::before,
            &::after {
                background: #02126a;
            }
        `};
`;
